import { createPostAsyncSlice } from '@sonar-software/xuder';
import { getJiraSummarySlice } from './summary/get';
import { postJiraCredentials } from '@api';

export const postJiraCredentialsSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successActionCreators: [ getJiraSummarySlice.asyncActionCreators.requestGetJiraSummary ]
	},
	name: 'jiraCredentials',
	receive: false,
	request: true,
	requestHandler: postJiraCredentials
});
